import { useEffect, useState } from "react";
import { getDocumentVat, VatRowDTO } from "../api/vat";

export function useDocumentVat(
  companyId: string,
  documentId: string
) {
  const [rows, setRows] = useState<VatRowDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    async function load() {
      if (!companyId || !documentId) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getDocumentVat(companyId, documentId);
        if (!active) return;
        setRows(data);
      } catch (err) {
        if (!active) return;
        setError("Nie udało się pobrać danych VAT");
      } finally {
        if (active) setLoading(false);
      }
    }

    load();

    return () => {
      active = false;
    };
  }, [companyId, documentId]);

  return {
    rows,
    loading,
    error,
  };
}
